// Etichette italiane centralizzate per il CRM (i valori tecnici restano nel backend).

export const OBLIGATION_LABELS = {
  acconto_sviluppo: "Acconto sviluppo",
  saldo_sviluppo: "Saldo sviluppo",
  mensilita: "Canone mensile",
  mantenimento_12: "Mantenimento annuale (12 mesi)",
  acconto_extra: "Acconto extra",
  saldo_extra: "Saldo extra",
  dominio: "Dominio",
  altro: "Altro",
};
export const olabel = (t) => OBLIGATION_LABELS[t] || t;
export const OBL_STATUS = { da_pagare: "Da pagare", contabile_ricevuta: "Contabile ricevuta", pagamento_verificato: "Pagamento verificato", incasso_confermato: "Incasso confermato", discrepanza: "Discrepanza" };
export const INVOICE_STATE = { da_richiedere: "Da richiedere", richiesta_comunicata: "Richiesta comunicata", fattura_emessa: "Fattura emessa" };
export const WORK_STATE = { in_attesa_materiali: "In attesa materiali", pronto_avvio: "Pronto all'avvio", avviato: "Avviato", in_lavorazione: "In lavorazione", in_revisione: "In revisione", consegnato: "Consegnato", online: "Online", sospeso: "Sospeso" };
export const DOMAIN_STATE = { da_registrare: "Da registrare", registrato: "Registrato", puntato: "Puntato", attivo: "Attivo" };

export const DOC_KIND_LABELS = {
  contratto_salone: "Contratto salone",
  extra: "Documento extra",
  altro: "Altro documento",
};
export const dockind = (t) => DOC_KIND_LABELS[t] || t;

export const SALE_KIND_LABELS = {
  sviluppo: "Sviluppo e personalizzazione GlowBit",
  mantenimento: "Mantenimento",
  extra: "Extra",
};
export const salekind = (t) => SALE_KIND_LABELS[t] || t;

export const PROFILE_FIELD_LABELS = {
  first_name: "Nome",
  last_name: "Cognome",
  phone: "Telefono",
  territory: "Territorio operativo",
  photo_url: "Foto profilo",
};
export const pfield = (k) => PROFILE_FIELD_LABELS[k] || k;

// ── Date in formato italiano ──
export function formatDateIT(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Rome" });
}
export function formatDateTimeIT(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Europe/Rome" });
}

// ── Notifiche leggibili (titolo + dettaglio dal payload) ──
const NOTIF_TITLE = {
  agent_submitted: "Nuova candidatura agente",
  agent_approved: "Candidatura approvata",
  agent_rejected: "Candidatura rifiutata",
  agent_integration_requested: "Richiesta integrazioni",
  agent_activated: "Account attivato",
  agent_suspended: "Account sospeso",
  agreement_sent: "Accordo da firmare ricevuto",
  agreement_signed_uploaded: "Copia firmata caricata dall'agente",
  agreement_correction_requested: "Correzione accordo richiesta",
  agreement_perfezionato: "Accordo perfezionato",
  contact_assigned: "Nuovo contatto assegnato",
  cancellation_requested: "Richiesta di annullamento vendita",
  cancellation_confirmed: "Annullamento confermato",
  cancellation_rejected: "Annullamento rifiutato",
  commission_previewed: "Nuova provvigione prevista",
  commission_matured: "Provvigione maturata",
  commission_liquidated: "Provvigioni liquidate",
  material_assigned: "Nuovo materiale di vendita",
  material_acknowledged: "Presa visione materiale confermata",
  obligation_created: "Nuovo pagamento previsto",
  payment_verified: "Pagamento verificato",
  receipt_uploaded: "Contabile caricata dall'agente",
  project_created: "Nuovo progetto",
  project_state: "Aggiornamento lavorazione progetto",
  project_ready: "Progetto pronto per l'approvazione",
  ticket_opened: "Nuova richiesta di assistenza",
  ticket_update: "Aggiornamento assistenza",
  ticket_reopened: "Assistenza riaperta",
  month_closed: "Chiusura mensile provvigioni",
  extra_requested: "Nuova richiesta extra",
  backup_failed: "Backup non riuscito",
  extra_rejected: "Preventivo extra rifiutato",
  extra_accepted: "Preventivo extra accettato",
  extra_ack: "Richiesta extra presa in carico",
  extra_quote: "Preventivo extra ricevuto",
  extra_commission_matured: "Provvigione extra maturata",
  extra_delivered: "Extra consegnato",
  prospetto_approved: "Prospetto approvato",
  agent_invoice_registered: "Fattura agente registrata",
  mode_change_requested: "Richiesta cambio modalità provvigionale",
  mode_change_approved: "Cambio modalità approvato",
  mode_change_rejected: "Cambio modalità rifiutato",
  document_to_sign: "Nuovo documento da firmare",
  document_signed: "Documento firmato",
  document_verified: "Documento verificato",
  document_correction_requested: "Correzione documento richiesta",
};

export function notifTitle(type) { return NOTIF_TITLE[type] || type; }

export function notifDetail(n) {
  const p = n.payload || {};
  switch (n.type) {
    case "material_assigned":
      return [p.title && `Materiale: ${p.title}`, p.version > 1 && `nuova versione v${p.version} — nuova presa visione richiesta`].filter(Boolean).join(" · ");
    case "material_acknowledged":
      return [p.agent_name && `Agente: ${p.agent_name}`, p.title && `Materiale: ${p.title}`, p.version && `v${p.version}`].filter(Boolean).join(" · ");
    case "document_signed":
      return [p.title, { da_verificare: "copia caricata da verificare", parzialmente_firmato: "parzialmente firmato", completato: "completato" }[p.status]].filter(Boolean).join(" · ");
    case "agreement_signed_uploaded":
      return p.agent_name ? `Agente: ${p.agent_name}` : "";
    case "document_verified":
    case "document_to_sign":
      return p.title || "";
    case "document_correction_requested":
      return [p.title, p.reason && `Motivo: ${p.reason}`].filter(Boolean).join(" · ");
    case "obligation_created":
      return p.type ? olabel(p.type) : "";
    case "payment_verified":
    case "receipt_uploaded":
      return p.amount != null ? `Importo € ${p.amount}` : "";
    case "project_created":
    case "project_ready":
      return p.salon_name ? `Salone: ${p.salon_name}` : "";
    case "project_state":
      return p.state ? `Stato: ${p.state}` : "";
    case "ticket_opened":
      return p.subject ? `Oggetto: ${p.subject}` : "";
    case "ticket_update":
      return p.state ? `Stato: ${p.state}` : "";
    case "extra_quote":
      return p.amount_net != null ? `Preventivo € ${p.amount_net}` : "";
    case "commission_liquidated":
      return p.month ? `Mese ${p.month}${p.net != null ? ` · € ${p.net}` : ""}` : "";
    case "month_closed":
      return p.month ? `Mese ${p.month}${p.count != null ? ` · ${p.count} vendite valide` : ""}` : "";
    case "mode_change_requested":
    case "mode_change_approved":
      return p.to_mode ? `Nuova modalità: ${p.to_mode === "fisso" ? "Compenso fisso a vendita" : "Percentuale a scaglioni"}` : "";
    case "agent_invoice_registered":
      return p.number ? `Fattura n. ${p.number}${p.month ? ` · ${p.month}` : ""}` : "";
    case "agreement_correction_requested":
    case "cancellation_rejected":
    case "mode_change_rejected":
      return p.reason ? `Motivo: ${p.reason}` : "";
    default:
      return "";
  }
}
